import { useState } from "react";
import "./certificates.css";
import Certificates1 from "../img/certificates/305025090161e - best deal electricals - iso 14001-2015_page-0001.jpg";
import Certificates2 from "../img/certificates/305025090162q - best deal electricals - iso 9001-2015_page-0001.jpg";
import Certificates3 from "../img/certificates/FINAL-  CE MARK-LVD- BEST DEAL ELECTRICALS_page-0001.jpg";

const Certificates = () => {
  const [certificates] = useState([
    { id: 1, img: Certificates1 },
    { id: 2, img: Certificates2 },
    { id: 3, img: Certificates3 },
  ]);

  return (
    <section className="py-5 certificate-section">
      <div className="container">
        <div className="position-relative heading-container mx-auto">
          <h2 className="heading products-heading ">
            C<span className="heading-span ">ERTIFICATES</span>{" "}
          </h2>
          <div className="line products-line"></div>
        </div>

        <div className="row py-5">
         <div
              className="col-10 col-md-4 gap-5 p-2 position-relative box-container certificates-box mx-auto ">
              <div className="position-relative box-container">
                <div className="box"> </div>
                <div className="box-elements d-flex justify-content-center align-items-center bg-light p-4">
                  <img src={Certificates3} className=" w-100" alt="certificate" />
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center ">
                <div className="text-center">
                  <h1 className="mb-3 heading bitcount-grid-double certificate-heading ">
            C<span className="heading-span certificates-span-heading">ERTIFICATE</span> O
            <span className="heading-span certificates-span-heading">F</span> C<span className="heading-span certificates-span-heading">OMPLIANCE </span>
          </h1> 
      <a href="/CERTIFICATE OF COMPLIANCE.pdf" target="_blank" className="text-decoration-none">  <div className="d-flex justify-content-center align-items-center ">  <button className="button about-button py-1">View »</button></div></a>
           </div>
            </div>
        </div>

        {/* //second */}
         <div className="row py-5">
         <div
              className="col-10 col-md-4 gap-5 p-2 position-relative box-container certificates-box mx-auto order-1 order-md-2">
              <div className="position-relative box-container">
                <div className="box"> </div>
                <div className="box-elements d-flex justify-content-center align-items-center bg-light p-4">
                  <img src={Certificates1} className=" w-100" alt="certificate" />
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center order-md-1 order-2">
                <div className="text-center">
                  <h1 className="mb-3 heading certificate-heading bitcount-grid-double ">
            E<span className="heading-span certificates-span-heading">NVIRONMENTAL</span> M
            <span className="heading-span certificates-span-heading">ANAGEMENT</span> S<span className="heading-span certificates-span-heading">YSTEM </span>
          </h1> 
       <a href="/ENVIRONMENTAL MANAGEMENT SYSTEM.pdf" target="_blank" className="text-decoration-none">  <div className="d-flex justify-content-center align-items-center ">  <button className="button about-button py-1">View »</button></div></a>
             </div>
            </div>
        </div>

{/* 3rd  */}
   <div className="row py-5">
         <div
              className="col-10 col-md-4 gap-5 p-2 position-relative box-container certificates-box mx-auto ">
              <div className="position-relative box-container">
                <div className="box"> </div>
                <div className="box-elements d-flex justify-content-center align-items-center bg-light p-4">
                  <img src={Certificates2} className=" w-100" alt="certificate" />
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center ">
                <div className="text-center">
                  <h1 className="mb-3 heading certificate-heading  bitcount-grid-double  ">
            Q<span className="heading-span certificates-span-heading">UALITY</span> M
            <span className="heading-span certificates-span-heading">ANAGEMENT</span> S<span className="heading-span certificates-span-heading">YSTEM </span>
          </h1> 
      <a href="/QUALITY MANAGEMENT SYSTEM CERTIFICATES.pdf" target="_blank" className="text-decoration-none">  <div className="d-flex justify-content-center align-items-center ">  <button className="button about-button py-1">View »</button></div></a>
           </div>
            </div>
        </div>

      </div>
    </section>
  );
};
export default Certificates;
